module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/document-container/document-container.style.scss
// module id = 871
// module chunks = 2